import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";
import { type InferOutput, boolean, object, picklist } from "valibot";

export const UpdateSmartReportFormSchema = object({
    cadence: picklist(["None", "Weekly", "BiWeekly", "Monthly"]),
    isMuted: boolean()
});

export type UpdateSmartReportForm = InferOutput<typeof UpdateSmartReportFormSchema>;

export const useUpdateSmartReportForm = (defaultValues: Partial<UpdateSmartReportForm>) => {
    return useForm<UpdateSmartReportForm>({
        defaultValues,
        resolver: valibotResolver(UpdateSmartReportFormSchema)
    });
};
